<template>
  <q-dialog
    v-model="shown"
    :maximized="$q.screen.lt.md"
    data-test-id="receipt-dialog"
  >
    <q-card style="min-width: 50%;">
      <q-banner
        v-if="siteId !== currentSite.id && !$consumer"
        class="bg-warning q-mb-sm sticky-banner"
      >
        <template #avatar>
          <q-icon
            name="warning"
            color="negative"
          />
        </template>
        {{ differentSiteWarning }}
      </q-banner>
      <q-card-section class="row items-center q-mx-xs">
        <div
          class="text-h6"
        >
          Receipt Order ({{ orderModel.id }})
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <!-- eslint-disable vue/no-v-html -->
      <!-- v-html produced by backend template -->
      <q-card-section class="row justify-center text-dark">
        <div v-html="orderModel.receiptHtml" />
      </q-card-section>
      <!-- eslint-enable vue/no-v-html -->
      <q-card-actions class="row justify-center q-ma-sm">
        <q-btn
          v-close-popup
          label="OK"
          color="primary"
          :text-color="$isColorDark(currentSite.primaryColor) ? 'white' : 'black'"
          class="full-width"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'ReceiptDialog',
  configuration: ['currentSite', 'sites'],
  props: {
    modelValue: {
      type: Boolean,
      required: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      printing: false,
      id: null,
      siteId: null,
      orderFromTokenId: null
    }
  },
  computed: {
    differentSiteWarning () {
      const siteName = this.sites.data.find(site => site.id === this.siteId)?.name
      return this.$admin
        ? `This order was placed on a different site (${siteName}).  Please change sites to view or manage it.`
        : `This order was placed on a different site (${siteName}).`
    },
    orderModel () {
      if (this.orderFromTokenId) {
        return this.findOrderByToken
      }
      return this.order
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
      if (this.shown) {
        this.$trackPage(this, { orderId: this.id })
      }
    }
  },
  methods: {
    show (id, siteId, orderFromTokenId = null) {
      this.id = id
      this.orderFromTokenId = orderFromTokenId
      this.siteId = siteId || this.currentSite.id
      this.shown = true
    }
  },
  models: {
    order: {
      fields: ['id', 'receiptHtml'],
      variables () {
        return {
          id: this.id,
          siteId: this.siteId,
          skip: !this.shown || !this.id
        }
      },
      force: true
    },
    findOrderByToken: {
      fields: ['id', 'receiptHtml'],
      variables () {
        return {
          token: encodeURIComponent(this.orderFromTokenId),
          siteId: this.siteId,
          skip: !this.shown || !this.orderFromTokenId
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.sticky-banner {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
